import { render } from "./TheSignup.vue?vue&type=template&id=13e7fdbc"
import script from "./TheSignup.vue?vue&type=script&lang=js"
export * from "./TheSignup.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__